import * as React from "react"
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews"

import { repositoryConfigs } from "./config/prismic/previews"
import { captureSessionAttribution } from "./src/utils/popupTracking"

// GTM is injected via SSR hooks in `gatsby-ssr.js` (head script + noscript after <body>).
// Intentionally left minimal to avoid duplicate or conflicting GTM loaders on the client.

const SITE_HOST = typeof window !== 'undefined' ? window.location.hostname : 'alpacked.io'

function enforceExternalRelInDOM() {
  if (typeof document === 'undefined') return
  try {
    const anchors = document.querySelectorAll('a[href^="http"]')
    anchors.forEach(a => {
      try {
        const url = new URL(a.href, window.location.origin)
        const isExternal = url.hostname && url.hostname !== SITE_HOST
        if (!isExternal) return
        const relNeeded = ['nofollow', 'noopener', 'noreferrer']
        const existing = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean)
        const merged = Array.from(new Set([...existing, ...relNeeded]))
        a.setAttribute('rel', merged.join(' '))
      } catch (_) {
        // ignore bad URLs
      }
    })
  } catch (_) {}
}

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
    {element}
  </PrismicPreviewProvider>
)

// Remember landing page / referrer / UTM params for this browser session so
// popup + form events can be attributed to the traffic source (see
// src/utils/popupTracking.js). Runs before the first render, while the URL
// still carries the campaign parameters.
export const onClientEntry = () => {
  captureSessionAttribution()
}

export const onInitialClientRender = () => {
  enforceExternalRelInDOM()
}

export const onRouteUpdate = () => {
  enforceExternalRelInDOM()
}
